"use client";

import { useSearch } from "@/contexts/SearchContext";
import { PropertyListingViewType } from "@/enums/property.enum";
import clsx from "clsx";
import dynamic from "next/dynamic";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useWindowSize } from "usehooks-ts";
import { FilterHeader } from "./FilterHeader";
import { PropertyListView } from "./PropertyListView";
import { PropertyListSEOContent } from "./SEOContent";

const DynamicMapView = dynamic(
  () => import("./PropertyMapView").then((mod) => mod.PropertyMapView),
  {
    ssr: false,
  }
);

// TODO: RENAME THIS TO PROPERTY LIST ONLY!
export const PropertyListPage = ({ content }: { content?: string }) => {
  const targetRef = useRef<HTMLDivElement>(null);

  const { width } = useWindowSize();
  const [boxHeight, setBoxHeight] = useState<number>(0);
  const { view } = useSearch();

  useLayoutEffect((): void => {
    setBoxHeight(
      (targetRef.current && targetRef.current?.getBoundingClientRect().top) ?? 0
    );
  }, [targetRef.current, view]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const htmlDocument = document.getElementsByTagName("html")[0];
      if (view === PropertyListingViewType.MAP) {
        htmlDocument.scroll({ top: 0, behavior: "instant" });
        htmlDocument.style.overflow = "hidden";
      } else {
        htmlDocument.style.overflow = "auto";
      }

      const navbar = document.getElementById("navbar");
      if (width < 768 && view === PropertyListingViewType.MAP) {
        if (navbar) {
          navbar.style.display = "none";
        }
      } else {
        if (navbar) {
          navbar.style.display = "flex";
        }
      }
    }

    return () => {
      if (typeof window !== "undefined") {
        const navbar = document.getElementById("navbar");
        const htmlDocument = document.getElementsByTagName("html")[0];
        htmlDocument.style.overflow = "auto";

        if (navbar) {
          navbar.style.display = "flex";
        }
      }
    };
  }, [view, width]);

  return (
    <div
      className={clsx(
        "relative grid grid-cols-1 h-full w-full overscroll-auto",
        {
          "px-2": view === PropertyListingViewType.LIST,
        }
      )}
    >
      <div
        className={clsx({
          "sticky top-0 z-40": view === PropertyListingViewType.LIST,
          "fixed sm:sticky h-28 w-full top-0 z-40":
            view === PropertyListingViewType.MAP,
        })}
      >
        <FilterHeader />
      </div>

      {view === PropertyListingViewType.MAP ? (
        <div
          // className={`h-[calc(100dvh-${boxHeight}px)]`} this won't work as tailwind will build the class during build time
          style={{ height: `calc(100dvh - ${boxHeight}px)` }}
          ref={targetRef}
        >
          <DynamicMapView />
        </div>
      ) : (
        <>
          <PropertyListView />
          {content && <PropertyListSEOContent content={content} />}
        </>
      )}
    </div>
  );
};
